import React from "react";
import { Loader2 } from "lucide-react";

export function Loader({ label }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-3 text-[#6B7280]" data-testid="loader">
      <Loader2 className="animate-spin text-[#FF3D5A]" size={32} />
      {label ? <span className="text-sm">{label}</span> : null}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-6 text-center" data-testid="empty-state">
      {Icon ? <Icon size={56} className="text-[#9CA3AF] mb-3" /> : null}
      <p className="text-base font-bold text-[#161629]">{title}</p>
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
